<template>
  <div>
    <div class="container-fluid" :class="{ 'disable-ske': !loading }">
      <div class="d-flex">
        <div style="width: 70%;" class="pr-5">
          <div style="position: relative;">
            <h3 class="card-title mr-2 mb-0 mt-0">
              {{ order ? order.title : '' }}
            </h3>
            <button type="button" @click="editSupplierOrder" class="btn btn-primary" style="position: absolute; right:0; top: 10px;">
              Edit order
            </button>
          </div>
          <div class="d-flex">
            <p class="mr-1 mb-0">
              Created at {{ dateFormat(order ? order.created_at : null) }}
            </p>
            <p class="ml-1 mb-0">
              Updated at {{ dateFormat(order ? order.updated_at : null) }}
            </p>
          </div>
          <hr class="my-3" />
          <div v-html="order ? order.description : ''"></div>
          <p>
            Attachments
          </p>
          <div class="content-wrapper card-wrapper">
            <div class="card raw-table-body">
              <div>
                <div class="table-content">
                  <div class="ComposableTable d-flex">
                    <table class="table w-full mb-0">
                      <tbody>
                        <tr v-for="(item, index) in attachments" :key="index">
                          <td width="50%">
                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M14.8438 10.6775L7.79186 17.7295C7.01827 18.503 5.96905 18.9376 4.87503 18.9376C3.781 18.9376 2.73178 18.503 1.95819 17.7295C1.1846 16.9559 0.75 15.9066 0.75 14.8126C0.75 13.7186 1.1846 12.6694 1.95819 11.8958L11.9865 1.86745C12.242 1.61213 12.5452 1.40962 12.8789 1.27149C13.2126 1.13335 13.5703 1.0623 13.9314 1.06239C14.2926 1.06247 14.6502 1.13369 14.9838 1.27198C15.3175 1.41027 15.6206 1.61293 15.8759 1.86837C16.1313 2.12381 16.3338 2.42704 16.4719 2.76075C16.61 3.09446 16.6811 3.4521 16.681 3.81327C16.6809 4.17443 16.6097 4.53204 16.4714 4.86569C16.3331 5.19933 16.1305 5.50246 15.875 5.75779L5.83936 15.7935C5.57901 16.043 5.23102 16.1794 4.87039 16.1749C4.50976 16.1703 4.16536 16.0242 3.91142 15.7681C3.65748 15.512 3.51433 15.1664 3.51283 14.8057C3.51132 14.4451 3.65157 14.0983 3.90336 13.84L11.0625 6.68087M5.84761 15.7843L5.83844 15.7935"
                                stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span style="margin-left: 10px;">
                              {{ item.filename }}
                            </span>
                          </td>
                          <td width="50%">
                            <span class="btn btn-primary btn-file">
                              Replace file(upload) <input type="file" name="file" @change="replaceAttachment(item.uid, $event)" />
                            </span>
                            <a class="btn btn-primary ml-1" :href="item.url" target="_blank">
                              Download
                            </a>
                            <button class="ml-3" @click="deleteAttachment(item.uid)">
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5" stroke="#6B7280" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="btn btn-primary btn-file">
                              Upload extra file <input type="file" name="file" @change="onFileChange" />
                            </span>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            Activity
          </p>
          <div class="comment">
            <div class="comment-item" v-for="(item, index) in activities" :key="index">
              <p :class="{ 'mb-0' : item.detail}">
                <span class="font-weight-bold"> {{ item.user.name }} </span> {{ item.action + ' '+ dateFormat(item.createdAt, true) }}
              </p>
              <p v-if="item.detail">
                {{ item.detail }}
              </p>
            </div>
            <div class="comment-item">
              <FormTextarea
                v-model="$v.comment.$model"
                placeholder="Comment..."
                :ske="true"
                rows="10"
                fieldName="comment"
                :vuelidate="$v"
              />
              <button class="btn btn-primary" @click="postComment">comment</button>
            </div>
          </div>
        </div>
        <div style="width: 30%;">
          <h4 class="font-weight-bold mt-0">
            Product
          </h4>
          <div class="col no-padding">
            <div id="carouselWithImageIndicators" class="carousel slide" data-ride="carousel">
              <ol class="carousel-indicators">
                <li data-target="#carouselWithImageIndicators" v-for="(image, index) in productImages" :data-slide-to="index" class="border border-secondary" :class=" index === 0? 'active' : '' ">
                  <img class="d-block w-100 h-100" :src="image.url" alt="" />
                </li>  
              </ol>
              <div class="carousel-inner">
                <div v-for="(image, index) in productImages" :key="index" class="carousel-item" :class="index === 0 ? 'active' : ''" >
                  <img class="d-block img-fluid" :src="image.url" alt="" />
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselWithImageIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselWithImageIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
          <div style="position: relative;">
            <h4 class="font-weight-bold m-0">
              {{ product ? product.name : '' }}
            </h4>
            <p>
              SKU: {{ product ? product.sku : '' }}
            </p>
            <p style="right: 10px; position: absolute; top: 5px;">
              € {{ product ? product.recommended_retail_price : '' }}
            </p>
          </div>
          <div class="m-0" v-html="product ? product.description: ''"></div>
          <h4 class="font-weight-bold">
            Settings
          </h4>
          <div class="row no-gutters">
            <div class="col-6" v-for="(item, index) in setting" :key="index">
              <p class="m-0 setting-title">
                {{ item.label }}
              </p>
              <p>
                {{ item.value }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { required } from "vuelidate/lib/validators"
import FormTextarea from "/src/components/Inputs/FormTextarea.vue"

export default {
  components: {
    FormTextarea
  },
  validations: {
    comment: {
      required
    }
  },
  data() {
    return {
      comment: null,
      loading: false,
      order: null,
      product: null,
      productImages: [],
      setting: [],
      activities: [],
      attachments: []
    }
  },
  created() {
    this.loadSupplierOrder()
    this.loadActivities()
    this.loadAttachments()
  },
  methods: {
    dateFormat(val, humanDiff = false) {
      if (!val) return val
      if (humanDiff) return moment(val).fromNow()
      return moment(val).format('MM/DD/YYYY')
    },
    async loadSupplierOrder() {
      this.loading = true
      const order = (await this.axios.get(`/api/supplier_orders/${this.id}`)).data
      if (order) {
        const { product, product: { setting = [] }, ...data } = order
        this.order = data
        this.product = product
        this.setting = setting

        const { results } = (await this.axios.get(`/api/products/${product.sku}/files`)).data
        this.productImages = results || [];
      }
      this.loading = false
    },
    async loadActivities() {
      this.loading = true
      const { results = [] } = (await this.axios.get(`/api/supplier_orders/${this.id}/activities`)).data
      this.activities = results
      this.loading = false
    },
    async loadAttachments() {
      this.loading = true
      const { results = [] } = (await this.axios.get(`/api/supplier_orders/${this.id}/attachments`)).data
      this.attachments = results
      this.loading = false
    },
    onFileChange(e) {
      const file = e.target.files[0]
      const payload = new FormData()
      payload.append('file', file)
      payload.append('type', 'base')

      this.$handlePromise(async () => {
        const attachment = (await this.axios.post(`/api/supplier_orders/${this.id}/attachments`, payload, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        })).data

        this.attachments.push(attachment)
        this.loadActivities()
      })
    },
    replaceAttachment(uid, e) {
      const index = this.attachments.findIndex(a => a.uid === uid)
      const file = e.target.files[0]
      const payload = new FormData()
      payload.append('file', file)
      payload.append('type', 'base')

      this.$handlePromise(async () => {
        const attachment = (await this.axios.put(`/api/supplier_orders/${this.id}/attachments/${uid}`, payload, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        })).data
        if (index > -1) this.attachments.splice(index, 1, attachment)
        this.loadActivities()
      })
    },
    async deleteAttachment(uid) {
      if (!uid) return
      this.$handlePromise(async () => {
        await this.axios.delete(`/api/supplier_orders/${this.id}/attachments/${uid}`)
        const index = this.attachments.findIndex(e => e.uid === uid)
        if (index > -1) this.attachments.splice(index, 1)
        this.loadActivities()
      })
    },
    postComment() {
      this.$v.$touch()
      if (this.$v.$error) return

      this.$handlePromise(async () => {
        await this.axios.post(`/api/supplier_orders/${this.id}/comments`, { comment: this.$v.comment.$model })
        this.comment = null
        this.$v.$reset()
        this.loadActivities()
      })
    },
    editSupplierOrder() {
      this.$pushModal({
        modal: "CreateSupplierOrder",
        toBind: {
          order: {...this.order, setting: this.setting},
          sku: this.product.sku,
          callback: this.loadSupplierOrder,
        },
      })
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    }
  }
}
</script>
<style>
.carousel-indicators li {
  border: 2px solid rgba(255, 255, 255, 0.5);
  height: 50px;
  margin-left: 2px;
  margin-right: 2px;
  opacity: 0.5;
  width: 50px;
}

.carousel-indicators li::after {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.75);
  content: '';
  display: block;
  height: 1px;
  width: 100%;
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-item {
  height: 200px;
}

.carousel-item img {
  height: 100% !important;
  width: 100%;
  object-fit: cover;
}

.carousel-control-prev-icon {
background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%33c9d2' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%33c9d2' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
}

.no-padding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.setting-title {
  color: #6d6e71;
}

.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  display: block;
  outline: none;
  cursor: inherit;
}
</style>